import { CustomRequest } from "vendor/infrastructure/custom_requests";
import { updateSending } from "vendor/application/disptach";

export class PlansAPI {
    constructor(token, props, body) {
        this.token = token;
        this.props = props;
        this.body = body;

        this.props.dispatch(updateSending(true));
    }

    async post_interest() {
        let request = new CustomRequest("POST", "plans/interest", JSON.stringify(this.body), this.token, this.props );
        var req = await request.action();
        this.props.dispatch(updateSending(false));
        return req;
    }
}